import i18n from "i18next";
import { durationToMillis } from "./durationToMillis";

export default function formatDuration(durationStr: string | number | null, ignoreSeconds = false) {
  const millis = typeof durationStr === "number" ? durationStr : durationToMillis(durationStr);
  if (!millis) return "";
  const totalSeconds = Math.floor(millis / 1000);
  const days = Math.floor(totalSeconds / (3600 * 24));
  const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  let formattedDuration = "";

  if (days > 0) {
    formattedDuration += `${days}${i18n.t("abrevtime.days")} `;
  }
  if (hours > 0 || days > 0) {
    formattedDuration += `${hours}${i18n.t("abrevtime.hours")} `;
  }
  if (minutes > 0 || hours > 0 || days > 0) {
    formattedDuration += `${minutes}${i18n.t("abrevtime.minutes")} `;
  }
  if (!isNaN(seconds) && !ignoreSeconds && formattedDuration !== "") {
    formattedDuration += `${seconds}${i18n.t("abrevtime.seconds")}`;
  }
  return formattedDuration.trim();
}
